import { Flex, ResourceList } from "@wayflyer/flyui";
import { FundingApplicationSchemas } from "@wayflyer/api-types";
import { useIntl } from "react-intl";
import { getAirResourceItems, useSpaNavigate } from "shared-ui";

/**
 * Renders a list of Additional Information Requests (AIRs) using ResourceList component
 * @component
 * @param {FundingApplicationSchemas.AdditionalInformationRequestWithMetaSchema[]} airs - Array of AIR items to display
 * @param {string} airPath - Base path for AIR navigation e.g. funding/application/<AIR_PATH>/0005
 */
export const AIRList = ({
  airs,
  airPath,
}: {
  airs: FundingApplicationSchemas.AdditionalInformationRequestWithMetaSchema[];
  airPath: string;
}) => {
  const { navigate } = useSpaNavigate("FundingApp");
  const intl = useIntl();

  const goToAirScreen = (airId: string) => {
    navigate(`${airPath}/${airId}`);
  };
  const airResourceItems = getAirResourceItems(intl, airs, goToAirScreen);

  return airResourceItems.length ? (
    <Flex direction="column" gap="3">
      <ResourceList hideFinalDivider>
        {airResourceItems.map((item) => (
          <ResourceList.NavigationActionItem key={item.id} {...item} />
        ))}
      </ResourceList>
    </Flex>
  ) : null;
};
